import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root",
})
export abstract class GenericResolver {
    // Abstract method for specific resolution logic
    protected abstract resolveCondition(): boolean;

    // Resolves by invoking the abstract condition
    resolve(): boolean {
        return this.resolveCondition();
    }
}
